export default function ({ $auth, $log }) {
  if (!$auth) {
    return
  }

  // Make $auth globally accessible for Pinia stores
  // For client-side access
  if (typeof process !== 'undefined' && process.client && typeof window !== 'undefined') {
    window.$auth = $auth
  }

  // For SSR context - make it globally accessible
  if (typeof process !== 'undefined' && process.server) {
    global.__NUXT_AUTH__ = $auth
  }

  $auth.onError((error, name, endpoint) => {
    if (error.config?.data) {
      error.config.data = 'sanitised error data'
    }
    try {
      $log({
        name: 'AuthError',
        properties: {
          onErrorName: name,
          endpoint,
          message: error.message,
          stack: error.stack,
          error,
        },
      })
    } catch {
      // Fail silently
    }
  })
}
